import api from '../config/api';
import { CashTransaction, CashTransactionCreatePayload, CashTransactionListResponse, CashBalance } from '../types';

export const cashService = {
  getBalance: async (): Promise<CashBalance> => {
    const res = await api.get('/api/cash/balance');
    return res.data;
  },

  getTransactions: async (page = 1, perPage = 20, transactionType?: string): Promise<CashTransactionListResponse> => {
    const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
    if (transactionType) params.set('transaction_type', transactionType);
    const res = await api.get(`/api/cash/transactions?${params.toString()}`);
    return res.data;
  },

  createTransaction: async (data: CashTransactionCreatePayload): Promise<CashTransaction> => {
    const res = await api.post('/api/cash/transactions', data);
    return res.data;
  },

  deleteTransaction: async (id: number): Promise<void> => {
    await api.delete(`/api/cash/transactions/${id}`);
  },
};
